import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { TabContextReporter } from '../TabContext';
import { Content, Component } from '../DataStructures';
import ComponentForms from '../forms/';
export default function DesignRow(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Overview"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Inner Components:")), props.data.children.map((v, k) => {
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "15px"
      }
    }, (k + 1).toString() + ". " + v.tagName)), /*#__PURE__*/React.createElement(Col, null, props.data.children.length > 1 && /*#__PURE__*/React.createElement(Button, {
      variant: "outline-danger",
      title: "Remove " + v.tagName,
      onClick: () => {
        props.data.children.splice(k, 1);
        props.onChanged();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    }))));
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add new TaskSelect",
    onClick: () => {
      props.data.children.push(new Component({
        tagName: "TaskSelect",
        props: {
          options: [new Content("A"), new Content("B"), new Content("C")],
          dropDownWidth: "100px",
          correct: 0,
          inline: true,
          label: new Content((props.data.children.length + 1).toString()),
          description: new Content("")
        }
      }));
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))), props.data.children.map((v, k) => {
    const ComponentForm = ComponentForms[v.tagName];
    return /*#__PURE__*/React.createElement(ComponentForm, {
      startingIndex: 1,
      onChanged: props.onChanged,
      data: v,
      openDataModal: props.openDataModal,
      scopeToItem: props.scopeToItem,
      triggerStateUpdate: props.triggerStateUpdate,
      onChange: props.onChanged,
      onValidityChange: props.setFormValid,
      decrementActiveTab: props.decrementActiveTab,
      refreshTabList: props.refreshTabList
    });
  }));
}